import Button from "..";
import styles from "./styles.module.scss";

export interface IItemDoubleButtonGroup {
  onClick_1: () => void;
  onClick_2: () => void;
  variant_1: "dark" | "lightDark";
  variant_2: "dark" | "lightDark";
  label_1: string;
  label_2: string;
  text: string;
}

interface IDoubleGroupButtons {
  data: IItemDoubleButtonGroup[];
}

const DoubleGroupButtons = ({ data }: IDoubleGroupButtons) => {
  return (
    <div className={styles.doubleGroupButtons}>
      {data.map((itemBtnGroup, index) => {
        return (
          <div
            className={styles.doubleGroupButtons__item}
            key={itemBtnGroup.label_1 + index}
          >
            <div className={styles.doubleGroupButtons__text}>
              {itemBtnGroup.text}
            </div>
            <div className={styles.doubleGroupButtons__buttons}>
              <Button
                label={itemBtnGroup.label_1}
                onClick={itemBtnGroup.onClick_1}
                variant={itemBtnGroup.variant_1}
              />
              <Button
                label={itemBtnGroup.label_2}
                onClick={itemBtnGroup.onClick_2}
                variant={itemBtnGroup.variant_2}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DoubleGroupButtons;
